import React from 'react'
import { Button } from 'antd'
import type { ButtonType } from 'antd/lib/button'

interface MessageItemButtonProps {
  icon: React.ReactNode
  label: string
  handleClick: () => void
  type?: ButtonType
  isBlocked?: boolean
  loading?: boolean
}

const MessageItemButton: React.FC<MessageItemButtonProps> = (props) => {
  const { icon, handleClick, label, type = 'dashed', isBlocked = true, loading = false } = props
  return (
    <Button
      type={type}
      htmlType='button'
      size='large'
      className='radius-100'
      shape='round'
      icon={icon}
      block={isBlocked}
      onClick={handleClick}
      loading={loading}
    >
      {label}
    </Button>
  )
}

export default MessageItemButton
